import React, { Component } from "react";
import FileImporter from "../deal_ui/import";
import {
  DKLabel,
  DKIcon,
  DKButton,
  DKLine,
  DKIcons,
  showToast,
  TOAST_TYPE,
  INPUT_VIEW_DIRECTION,
  INPUT_TYPE,
  DKInputForm,
  DKTooltipWrapper,
  removeLoader,
  showLoader,
  showAlert,
  DKListPicker2
} from "deskera-ui-library";
import ic_deals from "../../../assets/menu/ic_deals.png";
import ic_form from "../../../assets/menu/ic_form.png";
import ic_attachment from "../../../assets/icons/ic_attachment.png";
import Table from "../../../services/table";
import {
  COLUMN_CODE,
  TableManger,
  TABLES,
} from "../../../managers/TableManger";
import { LABEL_COLOR, LABEL_TYPE, VISIBILITY_TYPE } from "../../../constants/Enum";
import UserManager from "../../../managers/UserManager";
import Utility, { toCurrencyFormat } from "../../../utility/Utility";
import JobPipelineService from "../../common/Dashboard/JobPipeline";
import ApiConstants from "../../../constants/ApiConstants";
import RouteManager, { PAGE_ROUTES } from "../../../managers/RouteManager";
import i18next from 'i18next';
import { CANDIDATE_ACCEPT_FILE_TYPE, FILE_TYPE } from "../../../constants/Constant";
import { DealManager } from "../../../managers/DealManager";
import ShowAddEmployeePopup from "../../contacts/ShowAddEmployeePopup";
import { TENANT, TenantService } from "../../../managers/TenantManagerService";
import ic_add from '../../../assets/icons/ic_add.png'
import { renderFileHtml } from "../../../managers/common/CommonUtil";
import ContactManager from "../../../managers/ContactManager";
import PermissionUtils, { ACTION, MODULE } from "../../user-permissions/PermissionUtils";
class LeftPanel extends Component {
  pipelines = [];
  stageTableId
  pipelineTableId;
  selectedFileToUpload;
  documentList = []
  allAttachments = []
  fileUploadColumn = null;
  constructor(props) {
    super(props);
    this.state = {
      dealId: this.props.dealId,
      showLostReasonPopup: false,
      fileInfo: '',
      setData: '',
      showAddPipelinePopup:false,
      needPipelineListPicker: false,
      selectedPipelineIndex : -1,
      attachmentPopup:false,
      showAddEmployee:false,
      employeeData:null,
      selectedJobOpening:[]
    };
    this.ownerName = UserManager.getUserName();
    this.dealDetails = {};
    this.pipelineDetails = {};
    this.stageDetails = {};
    this.contactDetails = {};
    this.stageName = null;
    this.stageList = null;
    this.hiredId = null;
    this.rejectedId = null;
    this.stageTableId = TableManger.getTableId(TABLES.JOB_STAGE);
    this.pipelineTableId = TableManger.getTableId(TABLES.JOB_PIPELINE);
  }
  componentDidMount() {
    window['onDeleteAttachment'] = this.onDeleteteAttachement;
    this.getDealDetail();
  }
  onDeleteteAttachement=(url)=> {
    const path = Utility.decodeJSON(url)
    showAlert('Delete Attachment','Are you sure you want to delete?',[
      {
          title: "Continue",
          className: "bg-app text-white mr-r",
          onClick: () =>{ 
            this.deleteAttachmentAPI(path);
          }
      },
      {
          title: "Cancel",
          className: "bg-gray1 border-m",
          onClick: () => {},
      }
  ])
  }
  deleteAttachmentAPI=(path)=> {
    let dataToUpdate = {};
    let attachmentColID = TableManger.getColumnId(
      TABLES.CANDIDATE,
      COLUMN_CODE.CANDIDATE.DOCUMENT
    );
    const allDealDetails = this.dealDetails;
    let attachments = Utility.decodeJSON(allDealDetails['document'])
    if(path.columnId) {
      const indAttach = this.allAttachments.findIndex(a=>a.columnId === path.columnId)
      this.allAttachments[indAttach].attachments.splice(path.index,1)
      dataToUpdate = {
        [path.columnId]: Utility.encodeJSON(this.allAttachments[indAttach].attachments)
      }
    } else {
      attachments.splice(path.index,1);
      dataToUpdate= {
        [attachmentColID]: Utility.encodeJSON(attachments)
      } 
    }
    showLoader()
    Table.updateRecord(
      dataToUpdate,
      allDealDetails.id,
      this.dealTableId
    ).then((data) => {
      removeLoader()
      this.getDealDetail();
    },error=>{
      removeLoader()
    });
  }
  getDealDetail = () => {
    let dealColumns = {};
    let jobOpeningColumn = {}
    let fileTypeColumnIds = [];
    this.allAttachments = [];
    TableManger.getTableColumns(TABLES.CANDIDATE).forEach((column) => {
      dealColumns[column.columnCode] = column;
      if(column.columnCode === 'job_opening') {
        jobOpeningColumn = column
      }
      if(column.type === 'file' && column.columnCode !== COLUMN_CODE.CANDIDATE.DOCUMENT) {
        fileTypeColumnIds.push({columnId: column.id, name: column.name})
      }
    });
    this.dealTableId = TableManger.getTableId(TABLES.CANDIDATE);
    Table.getRecordById(this.state.dealId, this.dealTableId).then((deal) => {
      if (deal) {
        this.dealDetails = {
          id: this.state.dealId,
          name: deal.cells[dealColumns[COLUMN_CODE.CANDIDATE.NAME]?.id],
          email: deal.cells[dealColumns[COLUMN_CODE.CANDIDATE.EMAIL]?.id],
          phone: deal.cells[dealColumns[COLUMN_CODE.CANDIDATE.PHONE]?.id],
          address: deal.cells[dealColumns[COLUMN_CODE.CANDIDATE.ADDRESS]?.id],
          jobOpening: deal.cells[dealColumns[COLUMN_CODE.CANDIDATE.JOBOPENING]?.id][0],
          status: (deal.cells[dealColumns[COLUMN_CODE.CANDIDATE.STATUS]?.id])? deal.cells[dealColumns[COLUMN_CODE.CANDIDATE.STATUS]?.id][0]:'',
          pipeline_id: Array.isArray(deal.cells[dealColumns[COLUMN_CODE.CANDIDATE.JOB_PIPELINE_ID]?.id])
          ? deal.cells[dealColumns[COLUMN_CODE.CANDIDATE.JOB_PIPELINE_ID]?.id][0]
          : "",
          stage_id: (deal.cells[dealColumns[COLUMN_CODE.CANDIDATE.JOB_STAGE_ID]?.id])? deal.cells[dealColumns[COLUMN_CODE.CANDIDATE.JOB_STAGE_ID]?.id][0]: "",
          created_date: deal.createdAt,
          document: deal.cells[dealColumns[COLUMN_CODE.CANDIDATE.DOCUMENT]?.id],
          note: deal.cells[dealColumns[COLUMN_CODE.CANDIDATE.NOTE]?.id],
          userId: deal.cells[dealColumns[COLUMN_CODE.CANDIDATE.USER_ID]?.id] ? deal.cells[dealColumns[COLUMN_CODE.CANDIDATE.USER_ID]?.id] : "",
          note: deal.cells[dealColumns[COLUMN_CODE.CANDIDATE.NOTE]?.id],
          allPipelineIds :Array.isArray(deal.cells[dealColumns[COLUMN_CODE.CANDIDATE.JOB_PIPELINE_ID]?.id])?deal.cells[dealColumns[COLUMN_CODE.CANDIDATE.JOB_PIPELINE_ID]?.id]:[],
          allJobOpening: deal.cells[dealColumns[COLUMN_CODE.CANDIDATE.JOBOPENING]?.id],
          // By default visibility will be private
          visibility: 1,
          jobOpeningId:''
        //   type: deal.cells[dealColumns[COLUMN_CODE.CANDIDATE.TYPE].id],
        //   label: deal.cells[dealColumns[COLUMN_CODE.CANDIDATE.LABEL].id],
        //   profilePic: deal.cells[dealColumns[COLUMN_CODE.CANDIDATE.PROFILE_PIC].id][0]
        };
        if(!Utility.isEmpty(this.dealDetails.document) ) {
            try {
              this.documentList = Utility.decodeJSON(this.dealDetails.document);
            }
            catch(error) {
              this.documentList = []
            }
            
        }
        if(fileTypeColumnIds) {
          try {
            fileTypeColumnIds.forEach(fileObj=>{
              if(fileObj.columnId) {
                this.allAttachments.push({...fileObj, attachments: !Utility.isEmpty(deal.cells[fileObj.columnId]) ? Utility.decodeJSON(deal.cells[fileObj.columnId]):[]})
              }
            })
          } catch(e){

          }
        }
        
        let deal_age = Math.floor(
          (Date.parse(new Date().toISOString()) -
            Date.parse(this.dealDetails.created_date)) /
            86400000
        );
        this.dealDetails = {
          ...this.dealDetails,
          deal_age: deal_age === -1 ? 0 : deal_age,
        };
        let pipelineTableId = TableManger.getTableId(TABLES.JOB_PIPELINE);
        Table.getRecordsByPage(null, null, pipelineTableId)
        .then((res) => {

          this.pipelines = DealManager.parsePipelineData(res);
          if(!Utility.isEmpty(this.dealDetails.jobOpening) && jobOpeningColumn) {
            this.setState({
              ...this.state,
              selectedJobOpening:jobOpeningColumn.options.filter(op=>this.dealDetails.allJobOpening.find(id=>id===op.id))
            })
          } else {
            this.setState({
              ...this.state
            })
          }
          
        })

      }

      this.props.getDeal(this.dealDetails);
      this.setState({ dealDetails: this.dealDetails });
      this.getPipeline()
      if(!Utility.isEmpty(this.state.dealDetails.pipeline_id)) {
        this.getPipelineDetails();
      }
    //   this.getContactById();
    });
  };
  getPipelineDetails = () => {
    this.pipelineTableId = TableManger.getTableId(TABLES.JOB_PIPELINE);
    let pipelineColumns = {};
    TableManger.getTableColumns(TABLES.JOB_PIPELINE).forEach((column) => {
      pipelineColumns[column.columnCode] = column;
    });
    Table.getRecordById(
      this.state.dealDetails.pipeline_id,
      this.pipelineTableId
    ).then((pipeline) => {
      if (pipeline && pipeline.cells) {
        this.pipelineDetails = {
          name: pipeline.cells[pipelineColumns[COLUMN_CODE.JOB_PIPELINE.NAME].id],
          stage_ids: pipeline.cells[pipelineColumns[COLUMN_CODE.JOB_PIPELINE.STAGE_ID_S].id],
        };

      }
      this.setState({ pipelineDetails: this.pipelineDetails });
      this.getStageDetails();
    });
  };
  getStageDetails = () => {
    this.stageTableId = TableManger.getTableId(TABLES.JOB_STAGE);
    let stageColumns = {};
    let currentStage = {};
    TableManger.getTableColumns(TABLES.JOB_STAGE).forEach((column) => {
      stageColumns[column.columnCode] = column;
    });
    Table.getRecords(this.stageTableId).then((res) => {
      let stageIds = (this.state.pipelineDetails?.stage_ids) ? [...this.state.pipelineDetails?.stage_ids] :[];
      let stages = [];
      stageIds.forEach((stageId) => {
        let stageIndex = res.findIndex((details) => details._id === stageId);
        if (stageIndex != -1) {
          stages.push(res[stageIndex]);
          if (this.dealDetails.stage_id === res[stageIndex]._id) {
            currentStage = res[stageIndex];
            let selectedIndex = stageIds.findIndex(
              (s) => s === this.dealDetails.stage_id
            );
            if (selectedIndex != -1) {
              this.selectedStageIndex = selectedIndex;
            }
          }
        }
      });
      if(currentStage.cells) {
        this.stageName = currentStage.cells[stageColumns[COLUMN_CODE.JOB_STAGE.NAME].id];
        this.stageList = JobPipelineService.getStageData(stages)
        this.stageList.forEach(element=> {
            if(element.name == "Hired") {
                this.hiredId = element.id
            }
            if(element.name == "Rejected") {
                this.rejectedId = element.id
            }
        })
        this.stageDetails = {
            name: currentStage.cells[stageColumns[COLUMN_CODE.JOB_STAGE.NAME].id],
            stages: stages,
        };
      }

      this.setState({ stageDetails: this.stageDetails });
    });
  };

  getContactById = () => {
    const nameColumnId = TableManger.getColumnId(
      TABLES.CONTACT,
      COLUMN_CODE.CONTACT.NAME
    );
    const labelColumnId = TableManger.getColumnId(
      TABLES.CONTACT,
      COLUMN_CODE.CONTACT.LABEL
    );
    this.contactTableId = TableManger.getTableId(TABLES.CONTACT);
    if (this.state.dealDetails.contact_id) {
      Table.getRecordById(
        this.state.dealDetails.contact_id,
        this.contactTableId
      ).then((contact) => {
        if (contact) {
          this.contactDetails = {
            name: contact.cells[nameColumnId],
            label: contact.cells[labelColumnId][0],
          };
          this.setState({ contactDetails: this.contactDetails });
        }
      });

    } else {
      this.contactDetails = {
        name: 'No contact linked',
        label: '-',
      };
      this.setState({ contactDetails: this.contactDetails });
    }
  }

  getVisibility = (id) => {
    return VISIBILITY_TYPE["VISIBLITY_" + id];
  };
  getLabel = (id) => {
    return LABEL_TYPE["LABEL_" + id];
  };
  getLabelColor= (id) => {
    return LABEL_COLOR["COLOR_" + id];
  };
  updateState = (stage) => {
    const StageIdColumnId = TableManger.getColumnId(
        TABLES.CANDIDATE,
        COLUMN_CODE.CANDIDATE.JOB_STAGE_ID
      );
      const PipelineColumnId = TableManger.getColumnId(
        TABLES.CANDIDATE,
        COLUMN_CODE.CANDIDATE.JOB_PIPELINE_ID
      );
      let stageId = stage._id||stage.id
      let data = {
        [StageIdColumnId]: [

          stageId
        ],
        [PipelineColumnId]:[
          this.dealDetails.pipeline_id
        ]
      };

      Table.updateRecord(data, this.dealDetails.id, this.dealTableId).then((data) => {
        showToast(i18next.t("UPDATE_CONTACT_SUCCESS"), TOAST_TYPE.SUCCESS);
        this.getDealDetail();
      });
  };
  updatePipeline(){

    const StageIdColumnId = TableManger.getColumnId(
        TABLES.CANDIDATE,
        COLUMN_CODE.CANDIDATE.JOB_STAGE_ID
      );
      const PipelineColumnId = TableManger.getColumnId(
        TABLES.CANDIDATE,
        COLUMN_CODE.CANDIDATE.JOB_PIPELINE_ID
      );
      let data = {
        [StageIdColumnId]: [

          this.dealDetails.stage_id
        ],
        [PipelineColumnId]:[
          this.dealDetails.pipeline_id
        ]
      };
      if(this.dealDetails.stage_id) {
        Table.updateRecord(data, this.dealDetails.id, this.dealTableId).then((data) => {
          showToast(i18next.t("UPDATE_CONTACT_SUCCESS"), TOAST_TYPE.SUCCESS);
          this.getDealDetail();
        });
      } else {
        showToast(i18next.t("NOT_STAGE"), TOAST_TYPE.WARNING);
      }

  };
  updateJobStage=()=>{
    const JobOpeningColumnId = TableManger.getColumnId(
      TABLES.CANDIDATE,
      COLUMN_CODE.CANDIDATE.JOBOPENING
    );
    let data = {
      [JobOpeningColumnId]: [
        this.dealDetails.jobOpeningId
      ]
    };
    if(this.dealDetails.stage_id) {
      Table.updateRecord(data, this.dealDetails.id, this.dealTableId).then((data) => {
        showToast(i18next.t("UPDATE_CONTACT_SUCCESS"), TOAST_TYPE.SUCCESS);
        this.getDealDetail();
      });
    } else {
      showToast(i18next.t("NOT_STAGE"), TOAST_TYPE.WARNING);
    }
  }

  markDealAsLost = (data) => {
    this.setState({ showLostReasonPopup: false });
    const StageIdColumnId = TableManger.getColumnId(
        TABLES.CANDIDATE,
        COLUMN_CODE.CANDIDATE.JOB_STAGE_ID
      );
      let dataT = {
        [StageIdColumnId]: [

          this.rejectedId
        ],
      };
    Table.updateRecord(dataT, this.dealDetails.id, this.dealTableId).then(
      (data) => {
        showToast("Contact Marked As Rejected.", TOAST_TYPE.SUCCESS);
        this.getDealDetail();
      }
    );
  };
  resetStageName = () => {
    this.selectedStageIndex = this.state.stageDetails.stages.findIndex(
      (stage) => this.state.dealDetails.stage_id === stage._id
    );
    this.setState({
      ...this.state.stageDetails,
      name: this.state.stageDetails.name,
    });
    if(this.selectedStageIndex != -1) {
      this.stageName = this.state.columns[this.selectedStageIndex]?.name;
    } else {
      this.stageName = ""
    }

  };
  updateStageName = (index) => {
    const stageNameColumnId = TableManger.getColumnId(
      TABLES.JOB_STAGE,
      COLUMN_CODE.JOB_STAGE.NAME
    );
    this.setState({
      ...this.state.stageDetails,
      name: this.state.stageDetails.stages[index].cells ? this.state.stageDetails.stages[index].cells[stageNameColumnId]:(this.state.stageDetails.stages[index]?.name),
    });
    this.selectedStageIndex = index;
    this.stageName = (this.state.stageDetails.stages[index]?.cells) ? this.state.stageDetails.stages[index]?.cells[stageNameColumnId]:( this.state.stageDetails.stages[index] ? this.state.stageDetails.stages[index].name : '');
  };
  render() {
    return this.getLeftPanel();
  }

  getLeftPanel() {
    return (
      <>
      {this.state.showAddPipelinePopup && this.getAddPipelinePopup()}
      {this.state.attachmentPopup && this.attachmentPopup()}
      <div className=" border-box  mr-l pb-xxl" style={{ minWidth: 380, maxWidth: 380 }}>
        {this.state.dealDetails &&
          this.getSection1()}
        <DKLabel text="Other details" className="fw-m fs-m mt-xl" />
        {this.state.dealDetails && this.getSection2()}
        <DKLabel text="Attachments" className="fw-m fs-m mt-xl" />
        {this.state.dealDetails &&this.getDocumentSection()}
      </div>
      {this.state.showAddEmployee && (
          <div className="transparent-background">
            <ShowAddEmployeePopup
              employeeData={this.state.employeeData}
              onClose={(isRefresh) => {
                if(isRefresh) {
                  this.getDealDetail()
                }
                this.setState({
                  showAddEmployee:false
                })
              }}
              selectedRow = {this.state.actionRow}
            />
          </div>
        )}
      </>
    );
  }

  //////////////////////////////////////////////////////////////////////////////////////////

  getSection1() {
    return (
      <div className="parent-width p-l border-box bg-white border-radius-s">
        {this.getBasicInfo()}
        <DKLine className="m-v-xl" />
        {this.state.stageDetails && this.getStageView()}
      </div>
    );
  }

  showEmployee() {
    RouteManager.navigateToPage(
      PAGE_ROUTES.EMPLOYEE_DETAILS,
      `&id=${this.state.dealDetails.userId}&isEdit=true&step=0`
  );
  }
  addToEmployee() {
    let tenantData = TenantService.getData();
    let userData = {
      "firstName": this.dealDetails['name'],
      "lastName": "",
      "compensation": 0,
      "ctc": 0,
      "compensationCurrency": tenantData[TENANT.CURRENCY_CODE],
      "compensationPeriod": "30",
      "contact": "",
      "countryCode": tenantData[TENANT.COUNTRY_CODE],
      "emailId":this.dealDetails['email'],
      "makePayroll": true,
      "organizationName": tenantData[TENANT.ORGANIZATION_NAME],
      "name": this.dealDetails['name']
    }
    this.setState({
      showAddEmployee:true,
      employeeData : userData,
      actionRow : this.dealDetails
    })
  }
  getBasicInfo() {
    let isHiringAdmin = TenantService.get(TENANT.IS_HIRING_ADMIN);
    let isAdmin = TenantService.get(TENANT.IS_ADMIN);
    const cardHeight = ( Utility.isEmpty(this.state.dealDetails.userId)) ? '9rem' : '6rem';
    return (
      <div className="row justify-content-between" style={{ height: cardHeight }}>
        <div className="w-80 align-items-start " >
          <div className="d-flex  ">
          <DKIcon src={ic_deals} />
          <div className="column ml-m parent-width">
            <div className="row">
              <div className="width-90">
              <DKLabel
                text={this.state.dealDetails.name}
                className="fw-m text-blue fs-l"
              />
              </div>
              { (!Utility.isEmpty(this.state.dealDetails.userId) && !isHiringAdmin && isAdmin) && <div className="row-reverse" style={{marginLeft : "0px"}}>

                <DKButton
                  title="View Employee"
                  className="bg-app text-white fw-m"
                  onClick={() => this.showEmployee()}
                />
              </div>}
            </div>
            <DKLabel
              text={this.state.dealDetails.email}
              className="mt-s text-gray"
            />
            <DKLabel
              text={this.state.dealDetails.phone}
              className="mt-s text-gray"
            />
            {/*Note: Will use Later
            <DKLabel
              className="bg-chip-green text-green p-v-xs p-h-s border-radius-s mt-m border-green"
              text={
                this.state.pipelineDetails
                  ? this.state.pipelineDetails.name
                  : "-"
              }
            /> */}
            {this.getPipeLineDropdown()}
            { (Utility.isEmpty(this.state.dealDetails.userId) && TenantService.get(TENANT.IS_ADMIN)) && <div className="m-v-r">
                {PermissionUtils.hasAccess(MODULE.CANDIDATE, ACTION.EDIT)&&<DKButton
                  title="Add to Employee"
                  icon={ic_add}
                  className="bg-gray1 border-m cursor-hand fw-m"
                  onClick={() => this.addToEmployee()}
                />}
              </div>}
          </div>
        </div>
          </div>
        {(this.state.dealDetails.stage_id === this.hiredId || this.state.dealDetails.stage_id === this.rejectedId) && ( // '!==0
          <div className="column parent-height w-20">
            <div className={` ml-r p-v-xs p-h-s  border-radius-l ${(this.state.dealDetails.stage_id == this.hiredId) ? "bg-chip-green":"bg-chip-red"}`}>
              {(this.state.dealDetails.stage_id == this.hiredId) ? "Hired" : "Rejected"}
            </div>
          </div>
        )}
        {this.state.showLostReasonPopup && this.getDealLostReasonPopup()}
      </div>
    );
  }

  getStageView() {
    return (
      <div className="parent-width column">
        <div className="row">
          <DKLabel text="Current stage" className="fw-m" />
          <DKIcon src={DKIcons.ic_arrow_right2} className="ic-s" />
          <DKLabel
            className="bg-chip-blue p-v-xs p-h-s border-radius-s text-blue  border-blue display-block ml-s"
            text={(this.stageName && !Utility.isEmpty(this.stageName)) ? this.stageName : "-"}
          />
        </div>
        {this.state.stageDetails.stages && this.getStagesToggle()}
        <DKLabel
          text="Mouse over to see stages, click to select"
          className="mt-r text-gray ml-s mb-r"
        />
      </div>
    );
  }
  showHidePipelinePopup = () => {
    this.setState({ showAddPipelinePopup: !this.state.showAddPipelinePopup });
  };
  getPipeLineDropdown(){
    let title = this.dealDetails.allPipelineIds?.map(id=> this.pipelines.find(p=>p.id===id)?.pipelineName)
    let jobTitle = this.state.selectedJobOpening?.map(job=>job.name)
    title = [...title, ...jobTitle].join(', ')
     title = title ? title : 'Select';
    
    return <>{this.pipelines.length !== 0 && (
      <div className=" justify-content-between align-items-start mt-s " style={{width: 'inherit'}}>
        <div
          className="row justify-content-between p-h-r p-v-s border-m bg-white border-radius-m position-relative cursor-hand  shadow-m inner-div-pipeline"
          onClick={this.toggleVisibilityOfPipeline}
        >
          <DKTooltipWrapper 
          tooltipClassName="warning-tooltip-prop "
          content={title}>
            <DKLabel
            className="unselectable pipelineJobOpening"
            text={
              title
            }
          />
          </DKTooltipWrapper>
          <DKIcon
            src={DKIcons.ic_arrow_down2}
            className="ic-s unselectable ml-s"
          />
          {this.state.needPipelineListPicker &&
            this.getPipelineListPicker()}
        </div>
      </div>
    )}
    </>
  }
  
  toggleVisibilityOfPipeline = () => {
    this.setState({
      needPipelineListPicker: !this.state.needPipelineListPicker,
    });
  };
  getPipelineListPicker() {
    let pipelineNames = [];
    this.pipelines.forEach((pipeline) => {
      pipelineNames.push({id:pipeline.id,name:pipeline.pipelineName});
    });
    let dealColumns = {}
    let jobOpenings = []
    TableManger.getTableColumns(TABLES.CANDIDATE).forEach((column) => {
      dealColumns[column.columnCode] = column;
      if(column.columnCode === "job_opening") {
        column.options.forEach(op=>{
          if(typeof op.id === 'number') {
            jobOpenings.push(op)
          }
        })
      } 
    });
    pipelineNames = [...pipelineNames,...jobOpenings]
    const addJobBtn = PermissionUtils.hasAccess(MODULE.JOB_PIPELINE, [ACTION.CREATE]) ? {
      title: "+ Add Job Pipeline",
      className: "bg-app text-white",
      onClick: () => {
        this.showHidePipelinePopup();
      },
    }:null
    return (
      <DKListPicker2
        data={pipelineNames}
        className="position-absolute border-m shadow-m parent-width z-index-3"
        style={{ top: 36, left: 0, width: 170 }}
        onSelect={(index, value) => {
          this.changePipeline(index, value);
        }}
        renderer={(index,value)=>{
          return <DKTooltipWrapper 
            content={value.name}
            className="parent-width"
            tooltipClassName="warning-tooltip-prop ">
             
             <div className="ellipsis">
             {value.name}</div> 
            </DKTooltipWrapper>
          
        }}
        button={addJobBtn}
        onClose={() => {
          this.setState({ needPipelineListPicker: false });
        }}
      />
    );
  }
  changePipeline = (index, value) => {
    let SelectedPipeline = this.pipelines.find(
      (pipeline) => pipeline.id === value.id
    );
      let objToSet = {
        selectedPipelineId: SelectedPipeline,
        pipelineName: value.name
      }
      if(typeof value.id !== 'number') {
        objToSet = {...objToSet,selectedPipelineIndex: index}
      } else {
        objToSet = {...objToSet,selectedJobOpening: [value]}
      }
    this.setState(
      {
        ...objToSet
      },
      () => {
        if(typeof value.id !== 'number') {
          this.getStages(index)
        } else {
          this.dealDetails.jobOpeningId = value.id;
          this.updateJobStage()
        }
        
      }
    );
  };
  getAddPipelinePopup() {
    const direction = INPUT_VIEW_DIRECTION.VERTICAL;
    const fields = [
      {
        key: "pipeline_name",
        title: `${ i18next.t("PIPELINE_NAME") }`,
        type: INPUT_TYPE.TEXT,
        value: "",
        icon: DKIcons.ic_coupon,
        requestKey: TableManger.getColumnId(
          TABLES.JOB_PIPELINE,
          COLUMN_CODE.JOB_PIPELINE.NAME
        ),
      },
    ];
    return (
      <div className="transparent-background parent-height">
        <div className="popup-window" style={{ maxWidth: 450 }}>
          <div className="column parent-width">
            <div className="parent-width">
              <DKInputForm
                className=""
                direction={direction}
                title={` ${i18next.t("ADD_JOB_PIPELINE")} `}
                fields={fields}
                onCancel={() => {
                  this.showHidePipelinePopup();
                }}
                onSubmit={(data) => {
                  this.addPipeline(data);
                }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
  attachmentPopup() {
    return (
      <div className="transparent-background parent-height">
        <div className="popup-window" style={{ maxWidth: 450 }}>
          <div className="column parent-width">
            <div className="parent-width">
              <div className="row justify-content-between">
                <DKLabel className="fw-m fs-l" text="Add Attachment" />
                <div className="d-flex">
                  <DKButton
                    className="bg-gray1 border-m"
                    title={i18next.t("CANCEL")}
                    onClick={() => {
                      this.fileUploadColumn = null;
                      this.setState({ attachmentPopup: !this.state.attachmentPopup,fileInfo:'' })
                      this.selectedFileToUpload = null;

                    }} />
                  <DKButton
                    className="bg-app text-white ml-s"
                    title={i18next.t("UPLOAD")}
                    onClick={()=>{
                      if(this.selectedFileToUpload) {
                        this.upload(this.selectedFileToUpload)
                      }
                    }}
                  />
                </div>
              </div>
              <FileImporter
                fileInfo={this.state.fileInfo}
                acceptFileFormat={CANDIDATE_ACCEPT_FILE_TYPE}
                getFile={(param) => {
                  this.selectedFileToUpload = param
                  this.setState({
                    fileInfo:param.fileInfo
                  })

                }
              } />
            </div>
          </div>
        </div>
      </div>

    )
  }
  addPipeline = (pipelineData) => {
    const stageNameColumnId = TableManger.getColumnId(
      TABLES.JOB_STAGE,
      COLUMN_CODE.JOB_STAGE.NAME
    );
    const stageWonColumnId = TableManger.getColumnId(
      TABLES.JOB_STAGE,
      COLUMN_CODE.JOB_STAGE.WON_STAGE
    );
    const stageLostColumnId = TableManger.getColumnId(
      TABLES.JOB_STAGE,
      COLUMN_CODE.JOB_STAGE.LOST_STAGE
    );
    const stageHelpTextColumnId = TableManger.getColumnId(
      TABLES.JOB_STAGE,
      COLUMN_CODE.JOB_STAGE.HELP_TEXT
    );
    const stageIdsColumnId = TableManger.getColumnId(
      TABLES.JOB_PIPELINE,
      COLUMN_CODE.JOB_PIPELINE.STAGE_ID_S
    );
    const stageOrderColumnId = TableManger.getColumnId(
      TABLES.JOB_STAGE,
      COLUMN_CODE.JOB_STAGE.ORDER
    );
    let defaultStagesForNewPipeline = [];
    defaultStagesForNewPipeline.push({
      cells: {
        [stageNameColumnId]: i18next.t("NEW_STAGE"),
        [stageWonColumnId]: false,
        [stageLostColumnId]: false,
        [stageHelpTextColumnId]: i18next.t("NEW_STAGE"),
        [stageOrderColumnId]: 0,
      },
    });
    showLoader(`${i18next.t("ADDING_PIPELINE")}...`);
    Table.addBulkRecord(defaultStagesForNewPipeline, this.stageTableId).then(
      (response) => {
        let ids = [];
        response.data.forEach((stage) => {
          ids.push(stage._id);
        });
        let pipelineDataToSave = {};
        pipelineData.forEach((field) => {
          pipelineDataToSave[field.requestKey] = field.value;
          pipelineDataToSave[stageIdsColumnId] = ids;
        });
        Table.addRecord({ cells: pipelineDataToSave }, this.pipelineTableId)
          .finally(() => removeLoader())
          .then((data) => {
            showToast(`${i18next.t("PIPELINE_ADDED")}`, TOAST_TYPE.SUCCESS);
            this.getPipeline();
            this.setState({ showAddPipelinePopup: false });
          });
      }
    );
  };
  getPipeline = () => {
    let req = null;
    let payload = null;
    Table.getRecordsByPage(req, payload, this.pipelineTableId)
      .then((res) => {
        JobPipelineService.pipelineData = res.data;
        this.pipelines = DealManager.parsePipelineData(res);
        let index = this.pipelines.findIndex(rs=>this.dealDetails.pipeline_id==rs.id)
        this.setState(
          {
            pipelineName: this.pipelines[index].pipelineName,
            selectedPipelineIndex: index,
          },
          () => {
            this.getStages();
          }
        );
      })
      .catch((err) => {});
  };
  getStages = (index) => {

    if(index && index!=-1) {
      this.getDealDetailOnPipelineChange(this.pipelines[index].id)
    }

    Table.getRecordsByPage(null, null, this.stageTableId).then((res) => {
      JobPipelineService.stageData = res.data;
      DealManager.putStagesInPipeline(this.pipelines, res);
      this.stageDetails = {
        name: this.pipelines[this.state.selectedPipelineIndex].pipelineName,
        stages: this.pipelines[this.state.selectedPipelineIndex].stages,
      };
      this.pipelineDetails = {
        name: "",
        stage_ids: this.pipelines[this.state.selectedPipelineIndex].stages.map(r=>{return r.id}),
      };
      let dealDetails = {...this.state.dealDetails}

      if(index != undefined && index != -1) {
        this.dealDetails['pipeline_id'] = this.pipelines[index].id;
        this.dealDetails['stage_id'] = this.pipelineDetails.stage_ids[0]

      }
      this.dealDetails = {
        ...this.dealDetails,
        dealDetails: dealDetails
      }

      this.setState({
        columns: this.pipelines[this.state.selectedPipelineIndex].stages,
        pipelineDetails: this.pipelineDetails,
        dealDetails: this.dealDetails
      });

      this.getStageDetails()
      if(index != undefined && index != -1) {
        this.updatePipeline()
      }
    });
  };
  getDealDetailOnPipelineChange = (pipeLineId) => {
    let dealColumns = {};
    TableManger.getTableColumns(TABLES.CANDIDATE).forEach((column) => {
      dealColumns[column.columnCode] = column;
    });
    this.dealTableId = TableManger.getTableId(TABLES.CANDIDATE);
    Table.getRecordById(this.state.dealId, this.dealTableId).then((deal) => {
      if (deal) {
        this.dealDetails = {
          id: this.state.dealId,
          name: deal.cells[dealColumns[COLUMN_CODE.CANDIDATE.NAME].id],
          email: deal.cells[dealColumns[COLUMN_CODE.CANDIDATE.EMAIL].id],
          phone: deal.cells[dealColumns[COLUMN_CODE.CANDIDATE.PHONE].id],
          address: deal.cells[dealColumns[COLUMN_CODE.CANDIDATE.ADDRESS].id],
          jobOpening: deal.cells[dealColumns[COLUMN_CODE.CANDIDATE.JOBOPENING].id][0],
          status: (deal.cells[dealColumns[COLUMN_CODE.CANDIDATE.STATUS].id])? deal.cells[dealColumns[COLUMN_CODE.CANDIDATE.STATUS].id][0]:'',
          pipeline_id: pipeLineId,
          stage_id: (deal.cells[dealColumns[COLUMN_CODE.CANDIDATE.JOB_STAGE_ID].id])? deal.cells[dealColumns[COLUMN_CODE.CANDIDATE.JOB_STAGE_ID].id][0]: "",
          created_date: deal.createdAt,
          document: deal.cells[dealColumns[COLUMN_CODE.CANDIDATE.DOCUMENT].id],
          note: deal.cells[dealColumns[COLUMN_CODE.CANDIDATE.NOTE].id],
          userId: deal.cells[dealColumns[COLUMN_CODE.CANDIDATE.USER_ID].id] ? deal.cells[dealColumns[COLUMN_CODE.CANDIDATE.USER_ID].id] : "",
          note: deal.cells[dealColumns[COLUMN_CODE.CANDIDATE.NOTE].id],
          jobOpeningId:"",
          allPipelineIds : (deal.cells[dealColumns[COLUMN_CODE.CANDIDATE.JOB_PIPELINE_ID]?.id])?deal.cells[dealColumns[COLUMN_CODE.CANDIDATE.JOB_PIPELINE_ID]?.id]:[],
          allJobOpening: deal.cells[dealColumns[COLUMN_CODE.CANDIDATE.JOBOPENING]?.id],
          visibility: 1
        };
        let deal_age = Math.floor(
          (Date.parse(new Date().toISOString()) -
            Date.parse(this.dealDetails.created_date)) /
            86400000
        );
        this.dealDetails = {
          ...this.dealDetails,
          deal_age: deal_age === -1 ? 0 : deal_age,
        };
        let pipelineTableId = TableManger.getTableId(TABLES.JOB_PIPELINE);
        Table.getRecordsByPage(null, null, pipelineTableId)
        .then((res) => {

          this.pipelines = DealManager.parsePipelineData(res);
          this.setState({
            ...this.state
          })
        })

      }

      this.props.getDeal(this.dealDetails);
      this.setState({ dealDetails: this.dealDetails });
      if(this.state.dealDetails.pipeline_id) {
        this.getPipelineDetails();
      }

    });
  };
  renderFile = (file) => {
    let fileType = file.title?.split(".").pop();
    if (fileType === FILE_TYPE.TXT || fileType === FILE_TYPE.PDF) {
      return `<iframe width="180" src="${file.path}" title="${file.title}"></iframe>`;
    } else if (
      fileType === FILE_TYPE.JPG ||
      fileType === FILE_TYPE.JPEG ||
      fileType === FILE_TYPE.PNG ||
      fileType === FILE_TYPE.SVG
    ) {
      return `<img width="180" src="${file.path}" alt="${file.title}" />`;
    } else {
      return i18next.t('NO_PREVIEW');
    }
  };
  triggerAttachmentUpload = () => {
    const input = document.createElement('input');
    input.setAttribute('type', 'file');
    input.addEventListener('change', (e) => {
      const target = e.target ;
      target?.files &&
        Array.from(target.files).forEach((file) =>{
            this.upload(file)
        }
        );
    });
    input.click();
  };
  attachmentRenderer = (value) => {
    let attachment = [];
    if(PermissionUtils.hasAccess(MODULE.CANDIDATE,ACTION.EDIT)) {
      attachment.push(
        <div className="row parent-height parent-width cursor-hand">
          <DKButton title={`+ ${i18next.t('ADD_ATTACHMENT')}`}className="text-app fw-m pl-0 pt-0 pb-0 " onClick={()=>{
            this.fileUploadColumn = null
            this.setState({attachmentPopup:!this.state.attachmentPopup})
            }}/>
        </div>
      );
    }
    this.documentList?.forEach((data,index) => {
      attachment.push(
        <div className="row justify-content-between pt-l">
        <DKTooltipWrapper content={renderFileHtml(data,index)} tooltipClassName="">

          <DKButton
            title={data.title}
            icon={Utility.getFileIcon(data.title)}
            className="white-space-break ellipsis"
            style={{ padding: "0px 2px", opacity: 0.8 }}
            onClick={() => {
              window.open(data.path, "_blank");
            }}
          />

        </DKTooltipWrapper>
        </div>
      );
    });

    this.allAttachments?.forEach((data,index) => {
      attachment.push(
        <div className="row parent-height parent-width cursor-hand mt-l justify-content-between ellipsis">
          <DKTooltipWrapper className="ellipsis" content={`<div style="white-space: pre-wrap;">${data.name}</div>`} tooltipClassName="parent-width">
          <DKButton title={` ${data.name}`}className=" fw-m pl-0 pt-0 pb-0 ellipsis text-ellipsis" onClick={()=>{}} />
          </DKTooltipWrapper>
          
          <DKButton title={`+`}className="text-app fw-m pl-0 pt-0 pb-0 " onClick={()=>{
            this.fileUploadColumn = data.columnId;
            this.setState({attachmentPopup:!this.state.attachmentPopup})
          }} />
          
        </div>
      );
      
      const dataObj = data;
      data?.attachments?.forEach((attachmentData,index)=>{
        attachmentData['columnId'] = dataObj.columnId;
        attachment.push(
          <div className="row justify-content-between pt-l">
          <DKTooltipWrapper content={renderFileHtml(attachmentData,index)} tooltipClassName="">
            <DKButton
              title={attachmentData.title}
              icon={Utility.getFileIcon(attachmentData.title)}
              className="white-space-break ellipsis"
              style={{ padding: "0px 2px", opacity: 0.8 }}
              onClick={() => {
                window.open(attachmentData.path, "_blank");
              }}
            />  
          </DKTooltipWrapper>
          </div>
        );
      })
      if(data?.attachments?.length == 0) {
        attachment.push(<div className="row justify-content-between pt-s">- No Files</div>)
      }
      
      
    })

    return (
      <div>
        {attachment}
      </div>
    );
  };
  getFileLink() {
      return (
        <div className="parent-width  ">

          <div className="p-h-xl p-v-l">
            {this.attachmentRenderer(this.state.dealDetails.document)}
          </div>
        </div>

      )
  }
//   downloadURI(uri, name) {
//     const link = document.createElement("a");
//     link.download = name;
//     link.href = uri;
//     document.body.appendChild(link);
//     let blob = fetch(uri).then(r => r.blob());
//     link.href = uri;
//     link.click();
//     document.body.removeChild(link);
//   }
  getStagesToggle = () => {
    return (
      <div
        className="row parent-width mt-m stage-toggle-wrap"
        style={{ gap: 1 }}
      >
        {this.state.stageDetails.stages.map((stage, index) => {
          return (
            <div
              key={index}
              className={`parent-width cursor-hand stage-toggle-button bg-gray2 ${
                index <= this.selectedStageIndex ? "selected-stage" : ""
              }`}
              onClick={() => {
                if(!PermissionUtils.hasAccess(MODULE.CANDIDATE,ACTION.EDIT)) {
                  return
                }
                this.selectedStageIndex = index;
                this.updateState(stage);
              }}
              onMouseEnter={() => this.updateStageName(index)}
              onMouseLeave={() => this.resetStageName()}
              style={{ height: 20 }}
            ></div>
          );
        })}
      </div>
    );
  };
  getDealLostReasonPopup = () => {
    const direction = INPUT_VIEW_DIRECTION.VERTICAL;
    const dealReasonColumnId = TableManger.getColumnId(
      TABLES.DEAL,
      COLUMN_CODE.DEAL.REASON
    );
    const fields = [
      {
        key: "reason",
        title: "Contact Reject Reason",
        type: INPUT_TYPE.TEXT,
        value: "",
        requestKey: dealReasonColumnId,
        icon: DKIcons.ic_coupon,
      },
    ];
    return (
      <div className="transparent-background parent-height">
        <div className="popup-window" style={{ maxWidth: 450 }}>
          <div className="column parent-width">
            <div className="">
              <DKInputForm
                className=""
                style={{ width: 415 }}
                direction={direction}
                title="Contact Reject"
                fields={fields}
                dateFormat="MMM dd, yyyy"
                onCancel={() => {
                  this.setState({ showLostReasonPopup: false });
                }}
                onSubmit={(data) => {
                  this.markDealAsLost(data);
                }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };
  //////////////////////////////////////////////////////////////////////////////////////////

  getSection2() {
    return (
      <div className="parent-width p-xl border-box bg-white border-radius-s mt-m">
        <div className="row justify-content-between">
          <div className="row" style={{ width: "auto" }}>
            <DKIcon src={DKIcons.ic_quantity} className="ic-s mr-r" />
            <DKLabel text="Candidate age" />
          </div>
          <DKLabel
            text={`${this.state.dealDetails.deal_age} ${
              this.state.dealDetails.deal_age === 1 ? "Day" : "Days"
            }`}
            className="fw-m"
          />
        </div>
        <div className="row mt-xl justify-content-between">
          <div className="row" style={{ width: "auto" }}>
            <DKIcon src={DKIcons.ic_user_2} className="ic-s mr-r" />
            <DKLabel text="Owner" />
          </div>
          <DKLabel text={this.ownerName} className="fw-m" />
        </div>
        <div className="row mt-xl justify-content-between">
          <div className="row" style={{ width: "auto" }}>
            <DKIcon src={DKIcons.ic_key} className="ic-s mr-r" />
            <DKLabel text="Visibity" />
          </div>
          <DKLabel
            text={this.getVisibility(this.state.dealDetails.visibility)}
            className="fw-m p-v-xs p-h-s bg-gray1 border-radius-m border-m"
          />
        </div>
      </div>
    );
  }

  //////////////////////////////////////////////////////////////////////////////////////////

  getSection3() {
    return (
      <div className="parent-width p-xl border-box bg-white border-radius-s mt-m">
        <div className="row justify-content-between">
          <div className="row" style={{ width: "auto" }}>
            <DKIcon src={DKIcons.ic_user_2} className="ic-s mr-r" />
            <DKLabel text={this.state.contactDetails.name} />
          </div>
          <DKLabel text={this.getLabel(this.state.contactDetails.label)} className={`text-gray mr-s pt-xs pb-xs pl-s pr-s border-radius-s ${this.getLabelColor(this.state.contactDetails.label)}`} />
        </div>
      </div>
    );
  }
  getDocumentSection() {
    return (
        <div className="parent-width border-box bg-white border-radius-s mt-m">
          <div className="row justify-content-between">
          { this.getFileLink()}

          </div>
        </div>
      );
  }

  upload(param){
    const documentId = this.fileUploadColumn ? this.fileUploadColumn : TableManger.getColumnId(
        TABLES.CANDIDATE,
        COLUMN_CODE.CANDIDATE.DOCUMENT
      );
    const candidateTable = TableManger.getTableId(TABLES.CANDIDATE)

    var inputData = new FormData();
    inputData.append("file", param.fileContent);
    inputData.append("file-entity", "REPORT_THUMBNAIL");
    var requestOptions = {
        method: "POST",
        credentials: "include",
        withCredentials: true,
        mode: "cors",
        body: inputData,
   };
   showLoader()
   let urlObject = ApiConstants.URL;
   fetch(urlObject.BASE+urlObject.IMPORT_EXPORT.UPLOAD_FILE_PUBLIC, requestOptions)
   .then((response) => response.json())
   .then((responseData) => {
    var newAttachment = {
      title: param.fileContent.name,
      type: param.fileContent.type,
      path:  responseData.publicUrl,
    };
    let attachments = []
    if(this.fileUploadColumn) {
      const indAttach = this.allAttachments.findIndex(a=>a.columnId === this.fileUploadColumn)
      this.allAttachments[indAttach].attachments.push(newAttachment)
      attachments = this.allAttachments[indAttach].attachments
       
    } else {
      this.documentList.push(newAttachment);
      attachments = this.documentList;
    }
    
       let data = {
           [documentId]: btoa(encodeURI(JSON.stringify(attachments)))
       }
        Table.updateRecord(data,this.dealDetails.id,candidateTable).then((data) => {
            this.getDealDetail();
            this.fileUploadColumn = null;
            this.setState({ attachmentPopup: false,fileInfo:'' })
            showToast("File Uploaded successfully", TOAST_TYPE.SUCCESS);
            removeLoader();
        },error=>{
            showToast("Internal server error", TOAST_TYPE.FAILURE);
            removeLoader()
        });
   },error=>{
    this.fileUploadColumn = null;
    this.setState({ fileInfo:'' })
    this.selectedFileToUpload = null;
    if(error?.status === 500 && error?.message?.includes("CONTENT_TYPE_NOT_ALLOWED")) {
      showAlert(i18next.t('FAIL_TO_UPLOAD'), i18next.t('FILE_FORMAT_TYPE_ERROR_MSG'));
    }
    removeLoader()
   })
  }

  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////
}

export default LeftPanel;
